import styled from 'styled-components/macro';
import { colors } from 'roh-frontend/packages/roh-react';

const Info = styled.div`
  position: relative;
  padding: 16px 10px 16px 44px;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: ${colors.black};
  background: ${colors.white};
  border: 1px solid ${colors.alto};

  @media screen and (max-width: 767px) {
    font-size: 12px;
    line-height: 20px;
    padding: 12px 10px 12px 34px;
  }
`;

export default {
  Info,
};
